<template>
  <div class="page">
    <div class="img">
      <img src="~@/assets/img/new-img.jpg"/>
    </div>
    <div class="page-list">
      <div class="page-list-title">
        <el-tabs v-model="activeName"  @tab-click="handleClick" class="page-tabs">
          <el-tab-pane label="集团介绍" name="1"></el-tab-pane>
          <el-tab-pane label="组织机构" name="2"></el-tab-pane>
          <el-tab-pane label="企业荣誉" name="3"></el-tab-pane>
         </el-tabs>
      </div>

      <div class="info-details" v-if="activeName== '1'">
        <div class="info-details-title">{{data1.articleTitle}}</div>
          <div class="info-details-content">
            <div v-html="data1.articleContent"></div>
             <!--<div>-->
              <!--　　湖南省衡阳汽车运输集团有限公司创建于1950年元月，2000年7月改制为股份有限公司，2004年底通过ISO9001国际质量认证，是衡阳市唯一一家具有国家二级客运资质的运输企业。现有在职员工3939名，客货车辆1300余台。集团公司下设22个二级机构，拥有18个客货车队，11个保养场，2个一级客运站，7个二级客运站，40个区乡站，分布于衡阳市区及所辖的7个县。客运线路覆盖湖南、湖北、广东、广西、海南、云南、江西、浙江等省区。主要经营汽车客货运输、现代物流、城市公交、出租车、汽车修理、货物装卸、汽车燃润油料、汽车配件销售；旅馆、餐饮服务、商业贸易、广告装潢、房地产开发、物业管理、电子商务等。-->
            <!--</div>-->
            <!--<br/>-->
            <!--<div>-->
              <!--　　改制后的企业，更加注重企业文化建设，切实加强党的建设和“三个文明”建设，努力发挥党组织在企业的政治核心作用，用思想政治工作团结和凝聚员工，大力开展文明创建活动，并取得了丰硕成果。企业多次荣获全国及省市交通目标管理先进单位、经济效益先进单位、全国交通运输节能减排优秀贡献企业、湖南省优秀企业、湖南省思想政治工作先进企业、湖南省职工职业道德建设十佳单位、衡阳市企业文化建设先进单位、衡阳市一星级文明单位等荣誉称号。在新的历程里，公司奉行“建一流企业，争一流服务，创一流效益”的经营宗旨，加强企业文化建设，培育企业核心竞争力，以有效的科学管理手段，充分发挥各方面的优势，利用品牌与规模效应，不断扩大社会影响力，拓展业务覆盖范围，以客运为主业，乘风破浪、与时俱进，走规模化、集约化的经营道路，建立完善的现代企业制度，创造企业辉煌的明天！-->
            <!--</div>-->
          </div>
      </div>

      <div class="info-details" v-if="activeName== '2'">
        <div class="info-details-title">{{data2.articleTitle}}</div>
        <div   class="info-details-content" style="text-align: center;">
          <div v-html="data2.articleContent"></div>
        </div>
      </div>

      <div class="info-details" v-if="activeName== '3'">
        <div class="info-details-title">{{data3.articleTitle}}</div>
        <div  class="info-details-content">
          <div v-html="data3.articleContent"></div>
        </div>
      </div>


      <div></div>
    </div>
  </div>
</template>

<style scoped>
.info-details{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}

  .info-details-title{
    font-size: 30px;
    margin: 30px 30px 0px 30px;
  }

  .info-details-content{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0px  40px  40px  40px;
    letter-spacing: 1px;
    font-size: 18px;
    text-align: start;
    line-height: 40px;
  }
.info-details-content > div{
  width: 1200px;
}
</style>

<script>
  export default {
    name: "new",
    data () {
      return {
        activeName: '1',
        pageIndex: 1,
        pageSize: 5,
        totalPage: 0,
        data1:{
          articleTitle : '',
          articleContent: ''
        },
        data2:{
          articleTitle : '',
          articleContent: ''
        },
        data3:{
          articleTitle : '',
          articleContent: ''
        },
         state : false,
        classType : ''
      }
    },
    mounted: function () {
      this.activeName = this.$route.query.id+''
      this.getDataList()
     },
    watch: {
      '$route.query.id' (newValue, oldValue) {
        this.activeName = this.$route.query.id+''
        this.getDataList()
      },
      deep: false
    },
    methods: {
      handleClick(){

      },
      getDataList(){
         this.$http({
          url: this.$http.adornUrl('/website/getGroupInfo'),
          method: 'post',
          data: this.$http.adornData({
            "belongCity":16,
            "infoType":1,
            "pageSize":this.pageSize,
            "page":this.pageIndex
          })
        }).then(({data}) => {
           if (data && data.code === 0) {
            this.data1 = data.data
            } else {
            this.$message.error("服务器无响应!")
          }
        })

        this.$http({
          url: this.$http.adornUrl('/website/getGroupInfo'),
          method: 'post',
          data: this.$http.adornData({
            "belongCity":16,
            "infoType":2,
            "pageSize":this.pageSize,
            "page":this.pageIndex
          })
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.data2 = data.data
          } else {
            this.$message.error("服务器无响应!")
          }
        })

        this.$http({
          url: this.$http.adornUrl('/website/getGroupInfo'),
          method: 'post',
          data: this.$http.adornData({
            "belongCity":16,
            "infoType":3,
            "pageSize":this.pageSize,
            "page":this.pageIndex
          })
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.data3 = data.data
          } else {
            this.$message.error("服务器无响应!")
          }
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/modules/info.vue